import React, { useEffect, useState } from "react";
import { Col } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";
import HeadersProfile from "./HeadersProfile";
import InfoUsers from "./InfoUsers";

function PersonalFile({ data: propsData, isLoading: propsIsLoading }) {
  
  const [userData, setUserData] = useState(propsData?.data?.data);

  useEffect(() => {
    if (propsData?.data?.data) {
      setUserData(propsData.data.data);
    }
  }, [propsData]);

  useEffect(() => {
    if (userData) {
      sessionStorage.setItem("gender", userData.gender);
      sessionStorage.setItem("country_id", userData.nationality_residence?.country?.id);
      sessionStorage.setItem("employment_status_id", userData.study_work?.employment_status?.id);
      sessionStorage.setItem("nationality_id", userData.nationality_residence?.nationality?.id);
    }
  }, [userData]);

  if (propsIsLoading && !userData) {
    return <Loading />;
  }

  if (!userData) {
    return null; 
  }

  return (
    <>
      <Col md={11} className="mx-auto space-y-8 ">
        <Col>
          <HeadersProfile data={userData} />
        </Col>
        <Col>
          <InfoUsers data={userData} />
        </Col>
      </Col>
    </>
  );
}
export default PersonalFile;